export const trackGA = (event, data) => {
    if(!window.gtag){
        console.debug('GTAG NOT tracked, no gtag method');
        return;
    }
    const gtag_data = ['event', event, data];
    console.debug('GTAG tracked', gtag_data);
    window.gtag(gtag_data[0], gtag_data[1], gtag_data[2]);
};

export const trackFB = (event, data) => {
    if(!window.fbq){
        console.debug('Pixel NOT tracked, no fbq method');
        return;
    }
    console.debug('Pixel tracked', ['track', event, data]);
    window.fbq('track', event, data);
};

export const trackMS = (event, data) => {
    if(!window.uetq){
        console.debug('MS NOT tracked, no uetq variable');
        return;
    }
    console.debug('MS tracked', ['track', event, data]);
    window.uetq.push('event', event, data);
};
